import { render, staticRenderFns } from "./ProductCategoryTree.vue?vue&type=template&id=44c92564&scoped=true&"
import script from "./ProductCategoryTree.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryTree.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryTree.vue?vue&type=style&index=0&id=44c92564&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c92564",
  null
  
)

export default component.exports